export function roundToDecimals(num: number, decimals: number): number {
  const factor = Math.pow(10, decimals)
  return Math.round((num + Number.EPSILON) * factor) / factor
}
